import React, { useState } from "react";
import Campaigns from './Campaigns';
import CipherEvents from './CipherEvents';
import CohortsPage from './CohortsPage';

const Cipher = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const tabs = [
    { label: 'Events' },
    { label: 'Cohorts' },
    { label: 'Campaigns' }
  ];

  const styles = {
    primarycolor: "#0f172a",
    textSecondary: "#666666",
    borderColor: "#E5E7EB",
    backgroundColor: "#ffffff"
  };

  // Tab panel component
  const TabPanel = ({ children, value, index }) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`cipher-tabpanel-${index}`}
        aria-labelledby={`cipher-tab-${index}`}
      >
        {value === index && (
          <div className="py-4">
            {children}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Raleway, sans-serif' }}>
      <div className="px-6 pt-2 pb-6">
        {/* Tab Navigation Bar */}
        <div
          style={{
            borderBottom: `1px solid ${styles.borderColor}`,
            marginBottom: '24px'
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: 0,
              padding: 0
            }}
          >
            {tabs.map((tab, index) => {
              const isActive = currentTab === index;
              return (
                <button
                  key={tab.label}
                  onClick={() => setCurrentTab(index)}
                  style={{
                    border: 'none',
                    outline: 'none',
                    borderRadius: 0,
                    padding: '8px 16px',
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    backgroundColor: 'transparent',
                    color: isActive ? styles.primaryColor : styles.textSecondary,
                    position: 'relative',
                    borderBottom: isActive ? `2px solid ${styles.primaryColor}` : '2px solid transparent',
                    marginBottom: '-1px',
                    fontFamily: 'Raleway, sans-serif'
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.target.style.color = styles.primaryColor;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.target.style.color = styles.textSecondary;
                    }
                  }}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Panels */}
        <TabPanel value={currentTab} index={0}>
          <CipherEvents />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <CohortsPage />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <Campaigns />
        </TabPanel>
      </div>
    </div>
  );
};

export default Cipher;
